module.exports = __webpack_public_path__ + "nc_static/media/r_dKnowledge.cce3dcde.svg";